(function () {

    // prepare on load
    prepareSwatches();

    // prepare if product grid is refreshed
    document.addEventListener('theme:productGridRendered', function () {
        console.log('grid rendered');
        prepareSwatches();
    }, false);

    function prepareSwatches() {
        if ($('.card-information__swatches').length) {
            $('.card-swatches').each(function () {
                var currentProduct = $(this);
                var currentProductImage = currentProduct.find('.media img');
                var currentProductLink = currentProduct.find('.full-unstyled-link');
                // change product image to match swatch
                currentProduct.find('.swatches .swatch-link').each(function (index, element) {
                    var currentSwatch = $(this);
                    var swatchURL = currentSwatch.data("swatch-link");
                    var swatchImage = currentSwatch.data("swatch-image");
                    // on hover
                    currentSwatch.mouseenter(function () {
                        // remove active class from all swatches apart from the current one
                        currentProduct.find('.swatches .swatch-link').not(currentSwatch).removeClass("swatch-active");
                        // if the current swatch isn't already active...
                        if (!$(currentSwatch).hasClass("swatch-active")) {
                            currentSwatch.addClass("swatch-active");
                            currentProductLink.attr('href', swatchURL);
                            swapProductImage(swatchImage);
                        }
                    });
                    // let clicking swatch navigate to the correct variant
                    currentSwatch.click(function () {
                        window.location = swatchURL;
                    });
                });
                // swap product image
                function swapProductImage(image) {
                    var newProductImage = decodeURI(image).replace(/(\r\n|\n|\r)/gm, "");
                    // if the new image exists
                    if (newProductImage.indexOf('no-image') == -1) {
                        // stop any currently playing animations
                        currentProductImage.stop(true, true);
                        // fade out image element
                        currentProductImage.fadeOut(300, function () {
                            // swap image
                            currentProductImage.replaceWith(newProductImage);
                            // reassign current image
                            currentProductImage = currentProduct.find('.media img');
                            // fade in image element
                            currentProductImage.fadeIn(300);
                        });
                    }
                }
            });
        }
    }


})()
